export default "/images/circle-help.svg?e530e6da9ed43be6e5eadf8709e3f563";